import { Component, EventEmitter, Input, Output, SimpleChanges, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { ClientsService } from '../../../../core/services/clients/clients.service';
import { Subscription } from 'rxjs';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

interface ClientData {
  reference: string;
  name: string;
  lastname: string;
  email: string;
  phone: string;
  tax_id: string;
  fullname: string;
}
@Component({
  selector: 'app-guarantee-form',
  standalone: true,
  imports: [ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    NgSelectModule],
  templateUrl: './guarantee-form.component.html',
  styleUrl: './guarantee-form.component.css'
})
export class GuaranteeFormComponent implements OnDestroy {

  @Output() emitOpenAssigneeForm = new EventEmitter<boolean>();
  @Output() emitOpenClientForm = new EventEmitter<string>();

  @Output() emitRefreshGuarantee = new EventEmitter<any>();
  @Output() emitOpenMailPanel = new EventEmitter<{ reference: string; email: string; name: string }>();

  @Input() orderData?: any;
  @Input() ladata?: any = [];

  guaranteeForm: FormGroup = new FormGroup({});
  guaranteeFormExtra: FormGroup = new FormGroup({});
  updatesTabs: any[] = [];
account_type  : string = localStorage.getItem('account_type') || '';
  optionsVisibleClient = false;
  clientSearchTerm = '';
  displayTextClient = '';
  clearableClient = true;
  isClientInputDisabled: boolean = true;
  client_selector_spinner = false;
  filteredClients: any[] = [];


  optionsVisibleGuarantee = false;
  guaranteeSearchTerm = '';
  displayTextGuarantee = '';
  clearableGuarantee = true;
  isGuaranteeInputDisabled: boolean = true;
  filteredGuarantee: any[] = [];

  clientData: ClientData[] = [];
  searchParams: any = {};
  step = 1;

  genderOptions = [
    { key: 'male', label: 'male' },
    { key: 'female', label: 'female' },
  ];

  housingTypeOptions = [
    { key: 'rented' },
    { key: 'owned_deeded' },
    { key: 'owned_not_deeded' },
    { key: 'family_home' },
    { key: 'other' },
  ];

  maritalStatusOptions = [
    { key: 'single' },
    { key: 'married' },
    { key: 'divorced' },
    { key: 'separated' },
    { key: 'widowed' },
  ];

  employmentOptions = [
    { key: 'employee_permanent' },
    { key: 'employee_temporary' },
    { key: 'self_employed' },
    { key: 'retired' },
    { key: 'unemployed' },
    { key: 'no_employment' },
  ];

  constructor(private fb: FormBuilder, private fb2: FormBuilder, private alertService: AlertService, private clientsService: ClientsService, private orderService: OrdersService) {
    this.guaranteeForm = this.fb.group({
      guarantee_id: ['', Validators.required],
      guarantee_relationship: ['', Validators.required],
    });

    this.guaranteeFormExtra = this.fb2.group({
      guarantee_gender: [null],
      guarantee_marital_status: [null],
      guarantee_housing_type: [null],
      guarantee_monthly_net_income: [null, Validators.required],
      guarantee_employment_situation: [null],
      guarantee_employer_name: [null, Validators.required],
      guarantee_employer_tax_id: [null, Validators.required],
      guarantee_employer_from_date: [null, Validators.required],
      guarantee_employer_address: [null, Validators.required],
      guarantee_employer_postal_code: [null, Validators.required],
    });

  }

  private guaranteeSubscription!: Subscription;


  ngOnInit(): void {
    this.guaranteeSubscription = this.clientsService.guaranteeCreated$.subscribe(
      (data) => {
        // ✅ VALIDACIÓN: Solo procesar si es para ESTE pedido específico
        if (data && data.guarantee && this.orderData && this.orderData.reference) {
          // Si viene con orderReference, validar que coincida
          if (data.orderReference && data.orderReference !== this.orderData.reference) {
            return; // ⚠️ Este evento NO es para este pedido, ignorar
          }
          this.assignGuaranteeToOrder(data.guarantee);
        }
      });
  }

  assignGuaranteeToOrder(newClient: any) {
    this.filteredClients = [...this.filteredClients, newClient];

    this.guaranteeForm.patchValue({
      guarantee_id: newClient.reference,
    });

    this.displayTextGuarantee = `${newClient.name} ${newClient.lastname || ''}`;
    this.updateOrderWithNewClient(newClient);
    this.clientsService.resetGuarantee();
  }

  updateOrderWithNewClient(newClient: any) {
    const modifiedFields = {
      guarantee_id: newClient.reference,
    };

    this.orderService
      .updateData(this.orderData.reference, modifiedFields)
      .subscribe({
        next: (data) => {
          this.alertService.successOk('swal_messages.order_updated');
          this.orderData = data.data;
          this.emitRefreshGuarantee.emit(this.orderData);
          this.updatesTabs = [];
        },
        error: (error) => {
          this.alertService.error(error.error);
        },
      });
  }


  ngAfterViewInit() {

  }

  ngOnDestroy() {
    if (this.guaranteeSubscription) {
      this.guaranteeSubscription.unsubscribe();
    }
  }

  //PRINCIPAL FUNCTIONS
  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['ladata']) {
        if (this.orderData) {
          this.refrescarFormulario();
        }
      }

      if (changes['orderData']) {
        if (this.orderData) {
          this.refrescarFormulario();
        }
      }
    }
  }

  refrescarFormulario() {
    +this.setVariables();
    this.updateFieldAccessibility();

    if (!this.guaranteeForm.dirty) {
      for (const key in this.orderData) {
        const control = this.guaranteeForm.controls[key];
        const value = this.orderData[key];
        if (control) {
          control.setValue(value);
        }
      }

      for (const key in this.orderData) {
        const control = this.guaranteeFormExtra.controls[key];
        const value = this.orderData[key];
        if (control) {
          control.setValue(value);
        }
      }

      if (this.orderData?.guarantee) {
        this.displayTextGuarantee = `${this.orderData?.guarantee.name} ${this.orderData?.guarantee.lastname || ''}`;
      } else {
        this.displayTextGuarantee = '';
      }
    }

    this.alertService.close();
  }
  updateFieldAccessibility() {
    var rules = this.orderData?.rules;
    for (const field in this.guaranteeForm.controls) {
      if (this.guaranteeForm.controls.hasOwnProperty(field)) {
        this.guaranteeForm.get(field)?.disable();
      }
    }
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.guaranteeForm.get(field)?.enable();
      }
    }

       for (const field in this.guaranteeFormExtra.controls) {
      if (this.guaranteeFormExtra.controls.hasOwnProperty(field)) {
        this.guaranteeFormExtra.get(field)?.disable();
      }
    }
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.guaranteeFormExtra.get(field)?.enable();
      }
    }
    
    this.isGuaranteeInputDisabled = this.guaranteeForm.get('client_id')?.disabled ?? false;
  }

  setVariables() {
    if (!this.guaranteeForm.dirty || this.guaranteeForm.get('guarantee_id')?.value) {
      this.filteredGuarantee = this.orderData?.client
        ? this.addClientIfNotExists(this.orderData?.client, this.ladata.clientData)
        : this.ladata.clientData;
    }

    // this.client_reference = this.orderData?.client?.reference;
    // this.client = this.orderData?.client;
    // this.guarantee = this.orderData?.guarantee;
    // this.guarantee_reference = this.orderData?.guarantee?.reference;
  }

  addClientIfNotExists(
    singleClient: ClientData,
    clientArray: ClientData[]
  ): ClientData[] {
    if (!clientArray) {
      clientArray = [];
    }
    const clientExists = clientArray.some((client) =>
      this.areClientsEqual(client, singleClient)
    );
    if (!clientExists) {
      singleClient = {
        ...singleClient,
        fullname: `${singleClient.name}${singleClient.lastname ? ` ${singleClient.lastname}` : ''
          }`.trim(),
      };
      clientArray.push(singleClient);
    }
    return clientArray;
  }

  areClientsEqual(client1: ClientData, client2: ClientData): boolean {
    return client1.reference === client2.reference;
  }

  onFocus(term: string) {
    if (term === 'client') {
      this.optionsVisibleClient = true;
    } if (term === 'guarantee') {
      this.optionsVisibleGuarantee = true;
    }
  }

  hideOptions() {
    this.optionsVisibleClient = false;
    this.optionsVisibleGuarantee = false;
  }

  filterClients(term: string): ClientData[] {
    term = term.toLowerCase().trim();
    return this.clientData.filter((client) => {
      const nameMatches = client.name.toLowerCase().includes(term);
      const lastnameMatches =
        client.lastname && client.lastname.toLowerCase().includes(term);
      const taxIdMatches = client.tax_id.toLowerCase().includes(term);
      return nameMatches || lastnameMatches || taxIdMatches;
    });
  }

  searchClients(term: any) {
    this.client_selector_spinner = true;
    this.clientSearchTerm = term.value;
    let search = term.value;
    if (this.ladata && this.ladata.clientData) {
      this.filteredClients = this.ladata.clientData.filter(
        (clientData: any) =>
          clientData.name.toLowerCase().includes(search.toLowerCase())
      );
    }
    this.filterClients.length < 3 ? this.fetchClient(search) : null;
  }
  goClientForm(reference: string) {
    const nuevaURL = '/clients/' + reference;
    return nuevaURL;
  }

  onSelectGuarantee(event: any) {
    this.guaranteeForm.get('guarantee_id')?.setValue(event.reference);
    this.guaranteeForm.get('guarantee_id')?.markAsDirty();
    this.displayTextGuarantee = `${event.name} ${event.lastname}`;
    this.optionsVisibleGuarantee = false;

    if (this.guaranteeForm.get('guarantee_relationship')?.value === '') {
      this.guaranteeForm.get('guarantee_relationship')?.setValue(this.orderData?.guarantee_relationship || '');
    }
  }

  fetchClient(term: string): void {
    this.searchParams = {};
    this.searchParams['search'] = `%${term}%`;
    this.clientsService.searchClients(term).subscribe({
      next: (data) => {
        const updatedResponse = data.data.map((client: any) => {
          return {
            ...client,
            fullname: `${client.name}${client.lastname ? ` ${client.lastname}` : ''}`.trim(),
          };
        });
        this.filteredClients = updatedResponse;
        this.filteredGuarantee = updatedResponse;
        this.client_selector_spinner = false;
      },
      error: (error) => {

      },
    });
  }

  checkUpdateForm(): boolean {
    if (this.guaranteeForm.dirty) {
      return true;
    } else {
      return false;
    }
  }

  //EMITER
  openAssigneeForm() {
    this.emitOpenAssigneeForm.emit(this.orderData?.guarantee?.assignee);
  }

  openClientForm(optAdd: string) {
    this.emitOpenClientForm.emit(optAdd);
  }
  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

  extractPhoneNumber(phone: string): string {
    const regex = /\)\s*(\d+)/;
    const match = phone.match(regex);
    return match ? match[1] : '';
  }

  // ============ MAIL PANEL ============

  openMailModal(clientReference: string): void {
    this.emitOpenMailPanel.emit({
      reference: clientReference,
      email: this.orderData?.guarantee?.email || '',
      name: this.orderData?.guarantee?.name || '',
    });
  }

  removeGuarantee(): void {
    this.alertService.confirmation(
      'swal_messages.warning_confirm',
      'swal_messages.remove_guarantee_confirm',
      'swal_messages.confirm'
    ).then((result) => {
      if (result.isConfirmed) {
        this.markGuaranteeForRemoval();
      }
    });
  }

  private markGuaranteeForRemoval(): void {
    this.guaranteeForm.patchValue({
      guarantee_id: null,
      guarantee_relationship: ''
    });

    this.guaranteeForm.markAsDirty();

    this.guaranteeForm.get('guarantee_id')?.markAsDirty();
    this.guaranteeForm.get('guarantee_relationship')?.markAsDirty();
    this.guaranteeForm.get('guarantee_id')?.markAsTouched();
    this.guaranteeForm.get('guarantee_relationship')?.markAsTouched();

    this.displayTextGuarantee = '';

    this.alertService.success('swal_messages.guarantee_marked_for_removal');

  }

  getPendingChanges(): any {
    if (!this.guaranteeForm.dirty) {
      return null;
    }

    const formValues = this.guaranteeForm.value;
    const changes: any = {};

    if (this.guaranteeForm.get('guarantee_id')?.dirty) {
      changes.guarantee_id = formValues.guarantee_id;
    }

    if (this.guaranteeForm.get('guarantee_relationship')?.dirty) {
      changes.guarantee_relationship = formValues.guarantee_relationship;
    }

    return Object.keys(changes).length > 0 ? changes : null;
  }

  getFormChanges(): any {
    if (!this.guaranteeForm.dirty) {
      return null;
    }

    const changes: any = {};

    if (this.guaranteeForm.get('guarantee_id')?.dirty) {
      changes.guarantee_id = this.guaranteeForm.get('guarantee_id')?.value;
    }

    if (this.guaranteeForm.get('guarantee_relationship')?.dirty) {
      changes.guarantee_relationship = this.guaranteeForm.get('guarantee_relationship')?.value;
    }

    return Object.keys(changes).length > 0 ? changes : null;
  }

  private executeRemoveGuarantee(): void {
    this.alertService.loading('swal_messages.please_wait');

    const modifiedFields = {
      guarantee_id: null,
      guarantee_relationship: null,
    };

    this.orderService
      .updateData(this.orderData.reference, modifiedFields)
      .subscribe({
        next: (data) => {
          this.alertService.successOk('swal_messages.guarantee_removed');
          this.orderData = data.data;
          this.guaranteeForm.patchValue({
            guarantee_id: null,
            guarantee_relationship: null,
          });

          this.displayTextGuarantee = '';
          this.emitRefreshGuarantee.emit(this.orderData);
          this.updatesTabs = [];
        },
        error: (error) => {
          this.alertService.error(error.error);
        },
      });
  }
}
